export default __webpack_public_path__ + "locales/tr/Payments.json?hash=a0361021a86fce84a9a2fe1d6d896fa6";